var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPreloaderLife = function SvgPreloaderLife(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 16,
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, "@keyframes first-dot-animation{0%,to{opacity:.2}16.666667%,83.333333%{opacity:.4}33.333333%,66.666667%{opacity:.6}50%{opacity:.8}}@keyframes second-dot-animation{0%,66.666667%,to{opacity:.4}16.666667%,50%{opacity:.6}33.333333%{opacity:.8}83.333333%{opacity:.2}}@keyframes third-dot-animation{0%,33.333333%,to{opacity:.6}16.666667%{opacity:.8}50%,83.333333%{opacity:.4}66.666667%{opacity:.2}}@keyframes fourth-dot-animation{0%,to{opacity:.8}16.666667%,83.333333%{opacity:.6}33.333333%,66.666667%{opacity:.4}50%{opacity:.2}}")), /*#__PURE__*/React.createElement("circle", {
    cx: 2.5,
    cy: "50%",
    r: 2,
    fill: "#676767",
    fillRule: "evenodd",
    opacity: 0.2,
    style: {
      animation: "first-dot-animation 600ms linear infinite normal forwards"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: "50%",
    r: 2,
    fill: "#676767",
    fillRule: "evenodd",
    opacity: 0.4,
    style: {
      animation: "second-dot-animation 600ms linear infinite normal forwards"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18.5,
    cy: "50%",
    r: 2,
    fill: "#676767",
    fillRule: "evenodd",
    opacity: 0.6,
    style: {
      animation: "third-dot-animation 600ms linear infinite normal forwards"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 26.5,
    cy: "50%",
    r: 2,
    fill: "#676767",
    fillRule: "evenodd",
    opacity: 0.8,
    style: {
      animation: "fourth-dot-animation 600ms linear infinite normal forwards"
    }
  }));
};
export default SvgPreloaderLife;